import { Icon } from './Icon';

/** Способности и дебафы: разряд. */
export function BoltIcon({ size = 20 }: { size?: number }) {
  return (
    <Icon size={size} box={20}>
      <path d="M11 2.4 L4.6 11 H9.4 L8.6 17.6 L15.4 8.8 H10.4 Z" />
    </Icon>
  );
}
